import { Field, Float, InputType } from 'type-graphql'

// Provider-neutral checkout line item — always major units (pesos, dollars). Each gateway
// adapter converts to its own minor/major-unit convention internally (PayMongo centavos,
// HitPay major units) — no caller ever sees the gateway's unit.
@InputType()
export class CheckoutLineItem {
  @Field(() => String)
  name: string

  @Field(() => Float)
  amount: number

  @Field(() => Float)
  quantity: number

  @Field(() => String, { nullable: true })
  currency?: string
}
